'use client';

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
import { queryKeys } from '@/lib/queries/queryKeys';
import { fetchTestNotIncludedItems, type TestNotIncludedItem } from '@/lib/tests/testNotIncluded';

/**
 * Browser-side "test not included" items for the signed-in user, on one
 * content (event page) or all of them (My tests). Server time comes from
 * get_server_now so a wrong device clock cannot show or hide the notice.
 * A failed read shows no notice.
 */
export function useTestNotIncluded(userId: string | null | undefined, contentId?: string) {
  return useQuery<TestNotIncludedItem[]>({
    queryKey: queryKeys.testNotIncluded(userId ?? '', contentId),
    queryFn: async () => {
      const { data: serverNow } = await supabase.rpc('get_server_now');
      const now = serverNow ? new Date(serverNow as string) : new Date();
      try {
        return await fetchTestNotIncludedItems(supabase, { userId: userId!, contentId }, now);
      } catch (error) {
        console.error('Error loading test-not-included notices:', error);
        return [];
      }
    },
    enabled: !!userId,
    staleTime: 60 * 1000,
  });
}
